import { render, staticRenderFns } from "./mainSideRight.vue?vue&type=template&id=32ca6ad4&"
import script from "./mainSideRight.vue?vue&type=script&lang=js&"
export * from "./mainSideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports